// extracted by mini-css-extract-plugin
module.exports = {"photo":"ServiceSingle_photo__2M3Ur","info":"ServiceSingle_info__24bmq","step":"ServiceSingle_step__17isA","wrapper":"ServiceSingle_wrapper__3DmiT"};